export const BORROW_MARKET_DETAILS_STAT_VALUES = {
  borrowApy: 'borrowApy',
  utilization: 'utilization',
  totalSupplied: 'totalSupplied',
} as const

export type BorrowMarketDetailsStat =
  (typeof BORROW_MARKET_DETAILS_STAT_VALUES)[keyof typeof BORROW_MARKET_DETAILS_STAT_VALUES]
